import type {
	ContentType,
	Distribution,
	MixedItemDistResponse,
	MixedItemTag,
	PracticeTestExam,
} from "@memorang/types";

type Content = {
	id: string;
	type: ContentType;
	distribution: Distribution;
	totalCount: number;
};

const fetchPracticeTestContents = async (_bundleId: string) => {
	return {
		getMixedItemDistribution: {
			iconUrl: "",
			title: "",
			contents: [] as Content[],
			freeTagIds: [] as string[],
			tags: [] as MixedItemTag[],
			exams: [] as PracticeTestExam[],
			hasAccess: false,
		} satisfies MixedItemDistResponse,
	};
};

export default fetchPracticeTestContents;
